import { Component, OnInit, DoCheck , HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RestDataService } from '../../../service/rest-data.service';
import { Config } from '../../../config/config';
import { StaticDataService } from '../../../service/static-data.service';
import { HttpClient } from '@angular/common/http';
import { SharedDataService } from '../../../service/shared-data.service';
import { OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Unlisten } from '../../../keyboard-shortcuts/keyboard-shortcuts';
import { SnotifyService } from 'ng-snotify';
import { GoogleAnalyticsService } from '../../../service/google-analytics.service';

@Component({
  selector: 'app-page-footer',
  templateUrl: './page-footer.component.html',
  styleUrls: ['./page-footer.component.scss']
})

export class PageFooterComponent implements  OnInit, OnDestroy , DoCheck {
  subscription: Subscription;
  lastPageData = null;
  Category = 'story';
  id = this.route.snapshot.paramMap.get('id');
  page_id = StaticDataService.page_id;
  save_api = StaticDataService.page_save_api;
  get_api = StaticDataService.page_get_api;
  version_api = StaticDataService.page_version_api;
  lockAcquire_api = StaticDataService.page_lockAcquire_api;
  lockRelease_api = StaticDataService.page_lockRelease_api;
  unLockPage = StaticDataService.page_unlock_api;
  deleteArticleFromPage = StaticDataService.page_delete_articlefrompage;
  autosave: any;
  monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  showlockBg =false;
  pageLoaded = false;
  publishFlag = false;
  pageEditMode = false;
  isnavLinkIds = [];
  firstLoadCheck = 0;
  changeFlag = false;
  selectedFile: File = null;
  pageData: any;
  pageQuery: string;
  pageDesign = [];
  pageLinkIds = [];
  filteredpageDesign = [];
  ImageUrl: string;
  mergeArray: string;
  listOfHistoryArray: any[] = [];
  private unlisten: Unlisten;
  defaultPageData = JSON.parse(JSON.stringify(StaticDataService.defaultPageData));
  constructor( private router: Router,
    private route: ActivatedRoute,
    private snotify: SnotifyService,
    private http: HttpClient,
    private sharedService: SharedDataService,
    private restService: RestDataService,
    private gaService:GoogleAnalyticsService,
    private config: Config) {
    }

  ngOnInit() {
    this.sharedService.setTitle('page managment');
    this.sharedService.getData().subscribe(x => {
      if (x === 'pageNavPublish') {
        this.savePage(true);
      }
    });
    if (this.id !== null) {
      this.lockAcquire(this.id, flag => {
        if (flag) {
          this.initPageView(this.id, false);
          this.pageEditMode = true;
          this.publishFlag = false;
        } else {
          this.initPageView(this.id, true);
          this.pageLoaded = false;
          console.log('init wla lock not acquire');
          this.changeFlag = false;
          this.pageEditMode = false;
        }
      });
    } else {
      this.loadJqueryViewMethods();
      this.pageLoaded = true;
    }
    this.getDesignList();
  }
  ngDoCheck() {
    const localtempvar = this.pageData;
    if (localtempvar) {
       delete localtempvar['createdDate'];
       delete localtempvar['lastModifiedDate'];
    }
    const cochange = this.getDifference(this.lastPageData ? this.lastPageData : '', localtempvar ? JSON.stringify(localtempvar) : '');
    if (this.pageLoaded && cochange !== '') {
      if (localtempvar) {
        this.lastPageData = JSON.stringify(localtempvar);
      }
      if (this.firstLoadCheck > 0) {
        this.changeFlag = true;
        this.sharedService.sendData('saved|true');
      }
      this.firstLoadCheck++;
    }
    if (this.pageData && this.pageEditMode) {
      this.sendPublishDisableCommand(false);
    } else {
      this.sendPublishDisableCommand(true);
    }
  }

  sendPublishDisableCommand(flag) {
    if (flag) {
      this.sharedService.sendData('publish_disable|true');
    } else {
      this.sharedService.sendData('publish_disable|false');
    }
  }

  getDifference(a, b) {
    let i = 0;
    let j = 0;
    let result = '';

    while (j < b.length) {
      if (a[i] !== b[j] || i === a.length) {
        result += b[j];
      } else {
        i++;
      }
      j++;
    }
    return result;
  }
  getDeleteIdToParentfn(obj) {
    this.pageData.navigation = obj;
    this.overrideSave();
  }
  canDeactivate() {
    if (this.changeFlag) {
      const x = window.confirm('Discard changes?');
      if (!x) {
        this.loadJqueryViewMethods();
        return false;
      } else {
        if (this.pageData.id === null) {
          return true;
        } else {
          this.lockRelease(this.pageData.id, data => {
            console.log(data ? 'lock released of id=> ' + this.pageData.id : 'lock not released');
            return data;
          });
          return true;
        }
      }
    } else {
      if (this.pageData && this.pageData.id === null) {
        return true;
      } else {
        if (this.pageData) {
          this.lockRelease(this.pageData.id, data => {
            console.log(data ? 'lock released of id=> ' + this.pageData.id : 'lock not released');
            return data;
          });
          return true;
        }
      }
    }
  }
  @HostListener('window:resize') onResize() {
    this.loadJqueryViewMethods();
  }
  loadJqueryViewMethods() {
    if (this.pageLoaded) {
      this.generatePageAutoSaveInterval();
      this.sharedService.overflowauto();
  }
}
  initPageView(id, option) {
     this.restService.http_get(this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), this.page_id, this.get_api)
      + '/' + id)
      .subscribe(
      data => {
        this.sharedService.sendData('saved|false');
        this.pageData = data;
        this.pageLoaded = true;
        this.pageQuery = data.design;
        this.loadJqueryViewMethods();
        this.pageLinkIds = [];
        this.isnavLinkIds = [];
        this.pageLinkIds = data.navigation;
        for (let i = 0; i < this.pageLinkIds.length; i++) {
          if (this.pageLinkIds[i] !== null) {
            this.isnavLinkIds.push(this.pageLinkIds[i].id);
          }
        }
        const historyStr = this.pageData.modificationHistory;
        for (const key in historyStr) {
          if (key) {
            this.listOfHistoryArray.push({
              historyDate: key , name: historyStr[key]}
            );
          }
        }
        const currentDomain = sessionStorage.getItem(StaticDataService.domainLiteral);
        const role = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral))['user'].domainPermissions[currentDomain].role;
     if (option && role && (role === 'ROLE_ADMIN' || role === 'ROLE_SUPER_ADMIN')) {
          const { timeout, closeOnClick, ...config } = this.sharedService.getConfig('lock'); // Omit props what i don't need
          this.snotify.confirm('Locked by ' + data.lockedByUserName + ', Unlock?', '', {
            ...config,
            buttons: [
              {
                text: 'Yes', action: (toast) => {
                  this.snotify.remove(toast.id);
                  this.unlockPagepush(id, flag => {
                    if (flag) {
                      this.lockAcquire(id, flag2 => {
                        if (flag2) {
                          this.initPageView(id , false);
                          this.pageEditMode = true;
                        } else {

                        }
                      });
                    } else {
                      this.changeFlag = false;
                      this.pageEditMode = false;
                    }
                  });
                  this.googleAnalytics("Skippable Alerts",'Locked by ' + data.lockedByUserName + ', Unlock?',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'Yes' , null);
                }, bold: false
              },
              { text: 'No', action: (toast) => { this.snotify.remove(toast.id);
                this.googleAnalytics("Skippable Alerts",'Locked by ' + data.lockedByUserName + ', Unlock?',sessionStorage.getItem(StaticDataService.tenantName)+' '+ 'No' , null);
              } }
            ]
          });
        }

      },
      error => {
        this.router.navigate(['/page']);
      }
      );
  }
  googleAnalytics(eventCategory,eventAction,eventLabel,eventValue){
    this.gaService.gaEventView(eventCategory,eventAction,eventLabel,eventValue)
   }

  generatePageAutoSaveInterval() {
    if(!this.autosave) {
    this.autosave = setInterval(() => {
      this.savePage(false);
    }, 5000);
  }
  }
  destroyStoryAutoSaveInterval() {
    if (this.autosave) {
      clearInterval(this.autosave);
      this.autosave = null;
    }
  }
  ngOnDestroy() {
    this.destroyStoryAutoSaveInterval();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.snotify.clear();
    this.relaselocknow();
  }
  savePage(publishFlag) {
    this.publishFlag = publishFlag;
    if (publishFlag) {
      this.changeFlag = true;
    }
    if (this.changeFlag) {
        if (this.publishFlag || this.pageData.status === 'PUBLISHED' ) {
        this.pageData.status = 'PUBLISHED';
        }
        this.pageData.design = this.pageQuery;
        this.restService.http_put(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), this.page_id, this.save_api)
          + String(this.id) + (this.publishFlag ? '' : '?autoSave=true'),
          this.pageData,
          result => {
            this.changeFlag = false;
            this.pageData['lastModifiedDate'] = result['lastModifiedDate'];
            this.pageData['lastPublishedDate'] = result['lastPublishedDate'];
            this.pageData['lastModifiedBy'] = result['lastModifiedBy'];
            this.pageLinkIds = [];
            this.isnavLinkIds = [];
            this.pageLinkIds = result.navigation;
            for (let i = 0; i < this.pageLinkIds.length; i++) {
              if (this.pageLinkIds[i] !== null) {
                this.isnavLinkIds.push(this.pageLinkIds[i].id);
              }
            }
            this.sharedService.sendData('saved|false');
            if (this.publishFlag) {
              this.snotify.success('Updated and published successfully', '', this.sharedService.getConfig(false));
            }
          });
        }
  }
  onFileChange(event) {
    const fd = new FormData();
    this.selectedFile = <File>event.target.files[0];
    if (event.target.files && event.target.files.length > 0) {
      if ((this.selectedFile.size / 1000000) <= 11) {
      fd.append('file', this.selectedFile, this.selectedFile.name);
      this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadEndPoint, fd).subscribe(res => {
          this.pageData.coverImage = JSON.stringify(res['images'].original).replace(/"/gi, '');
        });
      } else {
        this.selectedFile = null;
        this.snotify.error('Image size exceeds 12 MB', '', this.sharedService.getConfig(false));
      }
    }
  }

  getListIdToParentfn(obj) {
    this.pageData.navigation = obj;
    this.overrideSave();
  }
  lockAcquire(story_id, callback) {
    this.restService.http_get(
      this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), this.page_id, this.lockAcquire_api)
      + '?pageId='
      + String(story_id)
    ).subscribe(
      data => {
        console.log('acquired => ' + data);
        callback(data);
      },
      error => {
        console.log('lock not acquired');
        callback(false);
      });
  }

  lockRelease(story_id, callback) {
    this.restService.http_get(
      this.config.get('product').baseUrl
      + this.config.getEndPoint(this.config.get('views'), this.page_id, this.lockRelease_api)
      + '?pageId='
      + String(story_id)
    )
      .subscribe(
      data => {
        console.log('released => ' + data);
        callback(data);
      },
      error => {
        console.log(error);
        callback(false);
      });
  }
  relaselocknow() {
    if (this.pageData && this.pageData.id !== null) {
      this.lockRelease(this.pageData.id, flag => {
        if (flag) {
          this.destroyViewComponents();
        }
      });
    } else {
      this.destroyViewComponents();
    }
  }
  @HostListener('window:unload', ['$event'])
  public onunload(event) {
    this.relaselocknow();
  }
  @HostListener('window:keydown', ['$event'])
  public hotkeys($event) {
    const key = $event.keyCode || $event.charCode;
    if (key === 83 && $event.ctrlKey
      || $event.metaKey && key === 83) {
      event.preventDefault();
      this.overrideSave();
  }
}

  @HostListener('window:beforeunload', ['$event'])
  public confirmUnload($event) {
    this.overrideSave();
    if (this.pageData && this.pageData.id !== null && this.changeFlag ) {
      const message = 'Changes are not saved, are you sure you want to leave?';
      if (typeof $event === 'undefined') {
        $event = window.event;
      }
      if ($event) {
        $event.returnValue = message;
      }
      return message;
    } else {
      return true;
    }
  }
  destroyViewComponents() {
    this.destroyStoryAutoSaveInterval();
    // tslint:disable-next-line:no-unused-expression
    (this.unlisten) && this.unlisten();
  }
  overrideSave() {
    this.destroyStoryAutoSaveInterval();
    setTimeout(e => {
      this.savePage(false);
      setTimeout(e2 => {
        this.generatePageAutoSaveInterval();
      }, 200);
    }, 200);
  }
  unlockPage() {
    this.unlockPagepush(this.id, flag => {
      if (flag) {
        this.lockAcquire(this.id, flag2 => {
          if (flag2) {
            this.initPageView(this.id, false);
            this.pageEditMode = true;
          } else {
            console.log('lock not acquired');
          }
        });
      } else {
        console.log('lock not acquired');
        this.changeFlag = false;
        this.pageEditMode = false;
      }
    });
    }
    unlockPagepush(page_id, callback) {
      this.restService.http_get(
        this.config.get('product').baseUrl
        + this.config.getEndPoint(this.config.get('views'), this.page_id, this.unLockPage)
        + '?pageId='
        + String(page_id)
      )
        .subscribe(
        data => {
          console.log('acquired => ' + data);
          this.destroyViewComponents();
          callback(data);
        },
        error => {
           console.log(error);
          console.log('lock not acquired');
          callback(false);
        });
    }
    getVersionDate(seconds) {
      if (seconds) {
        const date = new Date(seconds);
        const milliseconds = date.getTime();
        const res =
          (this.monthNames[date.getMonth()])
            + ' '
            + (date.getDate())
            + ', '
            + (date.getFullYear())
            + ' ['
            + ((date.getHours() < 10) ? '0' + date.getHours() : date.getHours())
          + ':'
          + ((date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes()
            + ']'
          );
        return res;
      } else {
        return 'not present';
      }
    }
getArticleIdToParentfn(obj) {
     if (!this.pageData.pageArticles) {
       this.pageData.pageArticles = [];
     }
     let flag = false;
     this.publishFlag = false;
     for (const index in this.pageData.pageArticles) {
       if (index) {
         const i = index;
         const pageList = this.pageData.pageArticles[i];
         if (pageList === obj) {
           this.pageData.pageArticles[i] = obj;
           flag = true;
           break;
         }
       }
     }
     if (!flag) {
       //if (obj.length > 0) {
         this.pageData.pageArticles = [];
         this.pageData.pageArticles = obj;
      //  } else {
      //    this.pageData.pageArticles.push(obj);
      //  }
       this.changeFlag = true;
      }
      this.overrideSave();
}
getDesignList() {
  this.restService.http_get(this.config.get('product').baseUrl + '/api/cms/page/design/all')
    .subscribe(
    data => {
      this.pageDataInsertion(data);
    },
    err => {
      console.log(err);
    }
    );
}
selectAutoCompletePage(item) {
  this.pageQuery = item.value;
  this.filteredpageDesign = [];
}
pageDataInsertion(data) {
  for (let i = 0; i < data.length; i++) {
    if (data[i] !== null) {
      this.pageDesign.push({'value' : data[i]});
    }
  }
}
filterAutoComplete() {
    if (this.pageQuery != null) {
      this.filteredpageDesign = this.pageDesign.filter(function (el) {
      return el.value.toLowerCase().indexOf(this.pageQuery.toLowerCase()) > -1;
    }.bind(this));
    } else {
      this.filteredpageDesign = this.pageDesign;
    }
  }
  getFullDate(seconds) {
    if (seconds) {
      const date = new Date(seconds);
      const res = (
        (date.getHours() < 10) ? '0' + date.getHours() : date.getHours())
        + ':'
        + ((date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes()
          + ' HRS, '
          + (this.monthNames[date.getMonth()])
          + ' '
          + (date.getDate())
          + ', '
          + (date.getFullYear())
        );
      return res;
    } else {
      return 'not present';
    }
  }

}
